import { getTenant } from './urlManipulation';

export interface MSIntegrationConfig {
  isPlannerEnabled: boolean;
  isTodoEnabled: boolean;
  hasBothEnabled: boolean;
  hasAnyEnabled: boolean;
}

/**
 * Detects which Microsoft integrations are enabled for the current tenant
 * based on environment variables
 */
export function getMSIntegrationConfig(): MSIntegrationConfig {
  const subdomain = getTenant();

  const isPlannerEnabled =
    import.meta.env[`VITE_${subdomain}_MSPLANNER_TENANT_ID`] !== undefined &&
    import.meta.env[`VITE_${subdomain}_MSPLANNER_CLIENT_ID`] !== undefined;

  const isTodoEnabled =
    import.meta.env[`VITE_${subdomain}_MSTODO_TENANT_ID`] !== undefined &&
    import.meta.env[`VITE_${subdomain}_MSTODO_CLIENT_ID`] !== undefined;

  return {
    isPlannerEnabled,
    isTodoEnabled,
    hasBothEnabled: isPlannerEnabled && isTodoEnabled,
    hasAnyEnabled: isPlannerEnabled || isTodoEnabled,
  };
}
